import { CrysbergLogsRequest } from '@/types/interfaceLog'
import axiosClient from '../axiosClient'

const interfaceLogApi = {
  /** Results are sorted oldest first and capped at 10,000 rows by the BE. */
  getCrysbergLogs(payload: CrysbergLogsRequest) {
    const url = '/api/InterfaceLog/crysberg-logs'
    return axiosClient.post(url, payload)
  },
}

export default interfaceLogApi
